// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner[data-v-b956259c]{color:#ffd500;background:#005bbb}.menu-items[data-v-b956259c]{-webkit-overflow-scrolling:touch;-ms-overflow-style:none;scrollbar-width:none}.menu-items[data-v-b956259c]::-webkit-scrollbar{display:none;width:0;background:transparent}.menu-items[data-v-b956259c] ::-webkit-scrollbar-thumb{background:transparent}", ""]);
// Exports
module.exports = exports;
